import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type Experience = {
  from: Date | null;
  to: Date | null;
  role: string;
  company: string;
  responsibilities: string[];
};

export type Education = {
  from:Date | null,
  to:Date | null,
  fieldofstudy: string;
  degree: string;
  college: string;
  city: string;
  // stream: string, 
  // institution: string
};
export type ResumeDetails = { 
  name?: string, 
  bio?: string,   
  email?: string,  
  explevel?: string, 
  contact?: string,
  experiences?: Experience[],
  skills?: [],
  achievements?: [],
  educations?: Education[],
  jobId?: string,
  resumeLink?: string,
  userId?: string
  _id?:string
     
      
};

export type ResumeState = {
    resumeDetails: ResumeDetails | null;
    resumeList: ResumeDetails[];
};


  
  // const initialState: ResumeState = {
  //   resumeDetails: null,
  // };

  const initialState: ResumeState = {
    resumeDetails: {
      name: "",
      bio: "",
      email: "",
      explevel: undefined,
      contact: "",
      experiences: [],
      skills: [],
      achievements: [],
      educations: [],
      jobId: '',
      resumeLink: '',
      userId: ''

    },
    resumeList: [],
  };

const resumeSlice = createSlice({
  name: "resumeSlice",
  initialState,
  reducers: {    
    setResumeDetails: (state, action: PayloadAction<Partial<ResumeDetails>>) => {
      //     console.log('ppp',action.payload);

      // Merge the new details into the existing state
      state.resumeDetails = {
        ...state.resumeDetails,
        ...action.payload,
      };
    },

    clearResumeDetails: (state) => {
      state.resumeDetails = initialState.resumeDetails;
    },

    //for Local Agency
    addResumeToList: (state, action: PayloadAction<ResumeDetails>) => {      
      if (!state.resumeList) {
        state.resumeList = []; // Initialize if undefined
      }
      state.resumeList.push(action.payload);
    },

    updateResume: (state, action: PayloadAction<{ index: number; data: Partial<ResumeDetails> }>) => {
      const { index, data } = action.payload;
      if (state.resumeList[index]) {
        state.resumeList[index] = {
          ...state.resumeList[index],
          ...data,
        };
      }
    },
    deleteResume: (state, action: PayloadAction<number>) => {
      state.resumeList.splice(action.payload, 1);
    },
    clearAllResumes: (state) => {
      state.resumeList = [];
    },
    
  },
  extraReducers: () => {},
});

export const { setResumeDetails, clearResumeDetails, addResumeToList, updateResume, clearAllResumes } = resumeSlice.actions;
export default resumeSlice.reducer;
